import Alt from 'alt';
const  alt = new Alt();

export default  alt;



// WEBPACK FOOTER //
// ./src/scripts/flux/alt/alt.js